import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import {
  GetEnumValuesDto,
  TransactionsWithPaginationItemDto,
  TypeTransactions,
} from 'src/app/core/api/models';
import { ExcelService, OutBoxMessagesService } from 'src/app/core/api/services';
import { AppFontSize } from 'src/app/core/types/app-font-size.type';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import { OrganizationTransactionsService } from '../../../../core/api/services/organization-transactions.service';
import { OrganizationTransactionsComponent } from '../../organization-transactions/organization-transactions.component';

@Component({
  selector: 'app-user-transactions',
  templateUrl: './user-transactions.component.html',
  standalone: false,
})
export class UserTransactionsComponent
  extends OrganizationTransactionsComponent
  implements OnInit
{
  pageName = PageNames.organizationTransactions;
  protected currentService = inject(OrganizationTransactionsService);
  @Input() modelWithPagination$: Observable<any>;
  items$: Observable<Array<TransactionsWithPaginationItemDto>>;
  get TypeTransactions() {
    return TypeTransactions;
  }
  @Input() userName: any;
  @Input() parentPageName: string;

  TypeCreditChangesEnumValues: GetEnumValuesDto[] = [];
  TypeTransactionsEnumValues: GetEnumValuesDto[] = [];
  fontSize: AppFontSize = 'sm';
  totalSum: number;

  @Output('onBack') output_onBack = new EventEmitter<boolean>();

  constructor(
    public outBoxMessagesService: OutBoxMessagesService,
    protected excelFileService: ExcelService,
    protected tabsDynamicComponent: TabsDynamicComponent
  ) {
    super(outBoxMessagesService, excelFileService, tabsDynamicComponent);
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.showAuditBtn = false;
    this.pageConfig.showAddBtn = false;
    this.pageConfig.showHelpBtn = false;
    this.pageConfig.showRefreshBtn = true;
  }

  //Get All
  getPaginationApi(): Observable<any> {
    return this.currentService
      .organizationTransactionsGetOrganizationTransactionsByUserIdWithPagination(
        {
          body: {
            ...this.getBaseModelWithPaginationParams(),
            userName: this.userName,
          },
        }
      )
      .pipe(tap((items: any) => this.calculateTotalSum(items?.data?.items)));
  }

  emitOnBack() {
    this.output_onBack.emit(true);
    this.unSubs();
  }
}
